import router from '.';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { Route } from 'vue-router';
import { UserModule } from '@/store/modules/user';
import { getUserInfo } from '@/api/users';
import { getUserToken, getLocUserToken, setLocUserToken, getNodeIdList, setUserToken } from '@/utils/cookies';
import { VShow } from './vids';

NProgress.configure({ showSpinner: false });

const whiteList = ['/register'];

router.beforeEach(async(to: Route, _: Route, next: any) => {
  // Start progress bar
  NProgress.start();
  let token: any = getUserToken();
  if (!token) {
    NProgress.done();
    // Has no token
    if (whiteList.indexOf(to.path) !== -1) {
      // In the free login whitelist, go directly
      next();
    } else {
      UserModule.ResetToken();
      window.location.href = location.protocol + process.env.VUE_APP_LOGIN_URL;
    }
    return;
  }
  if (typeof token !== 'object') {
    token = JSON.parse(token as string);
  }
  let isNew = true;
  let locToken = getLocUserToken();
  if (locToken && token && token.token && String(locToken) === String(token.token) && token.company_id === UserModule.getCompanyId) {
    setLocUserToken(token.token);
    isNew = false;
  } else {
    setLocUserToken(token.token);
    isNew = true;
  }
  if (token && token.token) {
    if (isNew) {
      let parameters: any = {};
      parameters.user_id = token.user_id;
      parameters.company_id = token.company_id;
      getUserInfo(parameters).then(async(res) => {
        await UserModule.setLogin(res.data);
        await checkNode(res.data.company, res.data.user, []);
      }
      ).catch(err => {
        let msg = err.msg;
        UserModule.ResetToken();
        window.location.href = location.protocol + process.env.VUE_APP_LOGIN_URL;
      });
    } else {
      if (getNodeIdList() === undefined) {
        let parameters: any = {};
        parameters.user_id = token.user_id;
        parameters.company_id = token.company_id;
        getUserInfo(parameters).then(async(res) => {
          await UserModule.setLogin(res.data);
          await checkNode(res.data.company, res.data.user, []);
        }).catch(err => {
          let msg = err.msg;
          UserModule.ResetToken();
          window.location.href = location.protocol + process.env.VUE_APP_LOGIN_URL;
        });
      } else {
        let nodeList: any = JSON.parse(getNodeIdList() as string);
        if (nodeList && nodeList.length > 0 && (UserModule.getCompanyId && parseInt(UserModule.getCompanyId) === parseInt(token.company_id))) {
          await checkNode(null, null, nodeList);
        } else {
          let parameters: any = {};
          parameters.user_id = token.user_id;
          parameters.company_id = token.company_id;
          await getUserInfo(parameters).then(async(res) => {
            await UserModule.setLogin(res.data);
            await checkNode(res.data.company, res.data.user, []);
          }
          ).catch(err => {
            let msg = err.msg;
            UserModule.ResetToken();
            window.location.href = location.protocol + process.env.VUE_APP_LOGIN_URL;
          });
        }
      }
    }
    let mobile = UserModule.getAccountMobile;
    let name = UserModule.getUserName;
    let checkUserId = UserModule.getUserId;
    //此方法在执行时会存在无用户 checkUserId有后再执行
    // && parseInt(UserModule.getIsCheckMobile) === 1 后台废除  特殊如果是企业微信账号 name=account的不要求完善手机号
    if (checkUserId &&  (!mobile || !name)  ) {
      //如果手机号为空 但是企业微信来的跳过 姓名与账号相等
      let checkAccount:string = UserModule.getAccount;
      // let checkUsername = UserModule.getUserName
      //非手机号
      if(checkAccount && checkAccount.length>11 ){
        next();
        NProgress.done();
        return;
      }
      if (to.path === '/Company/complete') {
        next();
        NProgress.done();
        return;
      }
      next({ path: '/Company/complete',
        query: { name: name, mobile: mobile },
        replace: true
      });
      NProgress.done();
      return;
    }
    if (to.name === 'Index') {
      let arr = (router as any).options.routes.filter((rt:any) => {
        return (rt && rt.name === 'IndexNew' && rt.meta && rt.meta.Permissions && !rt.meta.hidden);
      });
      if (arr && arr.length > 0) {
        let work:any = arr[0].children;
        let a = work.filter((rt:any) => {
          return (rt && rt.name === 'workIndex' && rt.meta && rt.meta.Permissions && !rt.meta.hidden);
        });
        if (a && a.length > 0) {
          next({
            name: 'workIndex',
            replace: true
          });
          return
        }
        let b = work.filter((rt:any) => {
          return (rt && rt.name === 'dashboardIndex' && rt.meta && rt.meta.Permissions && !rt.meta.hidden);
        });
        if (b && b.length > 0) {
          next({
            name: 'dashboardIndex',
            replace: true
          });
          return
        }
        let c = work.filter((rt:any) => {
          return (rt && rt.name === 'indexS' && rt.meta && rt.meta.Permissions && !rt.meta.hidden);
        });
        if (c && c.length > 0) {
          next({
            name: 'indexS',
            replace: true
          });
          return
        }
      } else {
        if (UserModule.company  &&  UserModule.company.vip_level != undefined && UserModule.company.vip_level.substring(0, 1) === '1') {
          next({
            name: 'OrderUnderway',
            replace: true
          });
        } else {
          next({
            name: 'orderServicerUnderway',
            replace: true
          });
        }
      }
    }
    // reload时 OrderUnderway orderServicerUnderway 没有时间t的重新跳转index
    if ((to.name === 'OrderUnderway' || to.name === 'orderServicerUnderway') && !to.query.t) {
      let arr = (router as any).options.routes.filter((rt:any) => {
        return (rt && rt.name === 'IndexNew' && rt.meta && rt.meta.Permissions && !rt.meta.hidden);
      });
      if (arr && arr.length > 0) {
        let work:any = arr[0].children;
        let a = work.filter((rt:any) => {
          return (rt && rt.name === 'workIndex' && rt.meta && rt.meta.Permissions && !rt.meta.hidden);
        });
        if (a && a.length > 0) {
          next({
            name: 'workIndex',
            replace: true
          });
          return
        }
        let b = work.filter((rt:any) => {
          return (rt && rt.name === 'dashboardIndex' && rt.meta && rt.meta.Permissions && !rt.meta.hidden);
        });
        if (b && b.length > 0) {
          next({
            name: 'dashboardIndex',
            replace: true
          });
          return
        }
        let c = work.filter((rt:any) => {
          return (rt && rt.name === 'indexS' && rt.meta && rt.meta.Permissions && !rt.meta.hidden);
        });
        if (c && c.length > 0) {
          next({
            name: 'indexS',
            replace: true
          });
          return
        }
      }
    }
    next();
    NProgress.done();
  } else {
    if (token) {
      next();
      NProgress.done();
    } else {
      if (whiteList.indexOf(to.path) !== -1) {
        next();
      } else {
        UserModule.ResetToken();
        window.location.href = location.protocol + process.env.VUE_APP_LOGIN_URL;
      }
    }
  }
});
function checkNode(rescompany: any, user: any, nodeList1: any) {
  let token: any = getUserToken();
  if (typeof token !== 'object') {
    token = JSON.parse(token as string);
  }
  let nodeList: any = [];
  if (nodeList1 && nodeList1.length > 0) {
    nodeList = nodeList1;
  } else {
    let company: any = {};
    if (rescompany && rescompany.length > 0) {
      company = rescompany[0];
    }
    let menu: any = [];
    if (company && company.role && company.role.node && token && parseInt(token.company_id) !== 0) {
      menu = company.role.node.menu;
    } else if (parseInt(token.company_id) === 0) {
      menu = user.node.menu;
    }
    if (menu && menu.length > 0) {
      menu.forEach((item: { id: number, child: any; }) => {
        nodeList.push(item.id);
        if (item.child && item.child.length > 0) {
          item.child.forEach((child: { id: number; }) => {
            nodeList.push(child.id);
          });
        }
      });
    }
  }
  if (nodeList && nodeList.length > 0) {
    (router as any).options.routes.forEach((item: { meta: { vid: string, hidden: boolean;Permissions:string }, children: any; }) => {
      if (item.meta.Permissions) {
        item.meta.hidden = !VShow(item.meta);
        if (item.children) {
          (item.children as any).forEach((child: { meta: { vid: string, hidden: boolean, Permissions:any }, children:[]; }) => {
            if (child.meta.Permissions) {
              child.meta.hidden = !VShow(child.meta);
              if (child.children) {
                (child.children as any).forEach((child: { path:string, meta: { vid: string, hidden: boolean, Permissions:any ,PermissionsOther:boolean}; }) => {
                  if (child.meta.Permissions) {
                    child.meta.hidden = !VShow(child.meta);
                    //20251222 菜单增加其他条件
                    if(child.path && child.path=="refuse" && child.meta.PermissionsOther==false){
                      child.meta.hidden = true;
                    }
                  } else {
                    child.meta.hidden = true
                  }
                });
              }
            } else {
              child.meta.hidden = true
            }
          });
        }
      } else {
        item.meta.hidden = true;
      }
    });
  } else {
    (router as any).options.routes.forEach((item: { meta: { vid: string, hidden: boolean, Permissions:any }, children: any; }) => {
      if (item.meta.Permissions) {
        item.meta.hidden = !VShow(item.meta);
        if (item.children) {
          (item.children as any).forEach((child: { meta: { vid: string, hidden: boolean, Permissions:any }, children:[]; }) => {
            if (child.meta.Permissions) {
              child.meta.hidden = !VShow(child.meta);
              if (child.children) {
                (child.children as any).forEach((child: { meta: { vid: string, hidden: boolean, Permissions:any }; }) => {
                  if (child.meta.Permissions) {
                    child.meta.hidden = !VShow(child.meta);
                  } else {
                    child.meta.hidden = true
                  }
                });
              }
            } else {
              child.meta.hidden = true
            }
          });
        }
      } else {
        item.meta.hidden = true;
      }
    });
  }
}
router.afterEach((to: Route) => {
  // Finish progress bar
  NProgress.done();

  // set page title
  // document.title = to.meta.title;
});
